export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel', // For .xls files
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // For .xlsx files
  'text/csv', // For CSV files
  'text/plain', // Sometimes CSV files are served with this type
];
export const ALLOWED_EXTENSIONS = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.csv'];
